import { ConfigurationApplicationStatus } from 'src/app/models/configurations/configuration-state';

export class Constants {
    /* PRIVACY POLICY AND TERMS & CONDITIONS URLs */
    public static get PRIVACY_POLICY_URL(): string { return 'https://www.temenos.com/legal-information/privacy-policy/'; }

    public static get TERMS_AND_CONDITIONS_URL(): string {
      return 'https://www.temenos.com/legal-information/website-terms-and-conditions/';
    }

    /* CAROUSEL STEP SIMULATION */
    public static get CAROUSEL_DEFAULT_INCREMENTATION_STEP(): number { return 3; }

    public static get CAROUSEL_DEFAULT_START_OFFSET(): number { return 0; }

    public static get CAROUSEL_DEFAULT_END_OFFSET(): number { return 3; }

    /* CATALOGUE FILTER PARAM */
    public static get CATALOGUE_FILTER_PARAM(): string { return 'filter'; }

    /* SERVICE EXPIRATION DAYS */
    public static get SERVICE_EXPIRATION_DAYS(): number { return 21; }

    /* VERSIONING */
    public static get VERSION_PATTERN(): string { return '^([0-9]+)[.]([0-9]+)[.]([0-9]+)$'; }

    public static get VERSION_DEFAULT_LEVEL_TO_INCREMENT(): string { return 'PATCH'; }

    public static get VERSION_DEFAULT_INITIAL_SEMANTIC_VERSION(): string { return '1.0.0'; }

    public static get VERSION_DEFAULT_INCREMENTATION_STEP(): number { return 1; }

    public static get VERSION_LEVEL_MAJOR(): string { return 'MAJOR'; }

    public static get VERSION_LEVEL_MINOR(): string { return 'MINOR'; }

    public static get VERSION_LEVEL_PATCH(): string { return 'PATCH'; }

    /* TOOLTIP POSITIONS */
    public static get POSITION_ABOVE(): string { return 'above'; }

    public static get POSITION_BELOW(): string { return 'below'; }

    public static get POSITION_LEFT(): string { return 'left'; }

    public static get POSITION_RIGHT(): string { return 'right'; }

    /* LEARNER MODE LABEL */
    public static get LEARNER_MODE(): string { return 'learner_mode'; }

    public static readonly ISO_DATE_FORMAT = 'yyyy-MM-yy';

    public static readonly DATE_TIME_FORMAT = 'dd MMM yy HH:mm:ss';

    public static readonly DATE_TIME_UTC_OFFSET = '+0000';

    public static readonly CONFIGURATION_FINAL_STATES = [
      ConfigurationApplicationStatus.CONFIGURE_FAILED,
      ConfigurationApplicationStatus.TEST_FAILED,
      ConfigurationApplicationStatus.SUCCESS,
      ConfigurationApplicationStatus.VERIFIED,
      ConfigurationApplicationStatus.FAILED
    ];

    /* TIME UNITS */
    public static get TIME_UNIT_DAY(): string { return 'days'; }

    public static get TIME_UNIT_HOUR(): string { return 'hours'; }

    public static get TIME_UNIT_SECOND(): string { return 'seconds'; }
}
